/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Kinds_LeadInputs */

const en_coaches_page_kinds_lead = /** @type {(inputs: Coaches_Page_Kinds_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A trainer, a dietician or a physio.`)
};

const pl_coaches_page_kinds_lead = /** @type {(inputs: Coaches_Page_Kinds_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener, dietetyk albo fizjoterapeuta.`)
};

/**
* | output |
* | --- |
* | "A trainer, a dietician or a physio." |
*
* @param {Coaches_Page_Kinds_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_kinds_lead = /** @type {((inputs?: Coaches_Page_Kinds_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Kinds_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_kinds_lead(inputs)
	return en_coaches_page_kinds_lead(inputs)
});